import React from 'react'
import InputBase from '@material-ui/core/InputBase'
import { fade as alpha /** FIXME MUI update */, makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import { useHistory } from 'react-router-dom'
import { Routes } from '../../../consts'
import { useCprmSearch } from '../../pages/Search/hooks'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25)
      },
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(3),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 'auto'
      }
    },
    searchIcon: {
      width: theme.spacing(7),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    inputRoot: {
      color: 'inherit'
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 7),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 300
      }
    }
  })
)

interface Props {}

const Component: React.FC<Props> = () => {
  const classes = useStyles()
  const history = useHistory()

  const { handleFreewords, handleIsSearched } = useCprmSearch()

  const [freewords, setFreewords] = React.useState<string>('')
  const [loading, setLoading] = React.useState<boolean>(false)

  const handleSearch = () => {
    setLoading(true)
    handleFreewords(freewords)
    handleIsSearched(true)
    history.push(Routes.Search.path)
    setFreewords('')
    setLoading(false)
  }

  return (
    <>
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Find papers in CPSYMAP database"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput
          }}
          inputProps={{ 'aria-label': 'search' }}
          disabled={loading}
          value={freewords}
          onChange={e => {
            setFreewords(e.target.value)
          }}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              handleSearch()
            }
          }}
        />
      </div>
    </>
  )
}

export default Component
